import React, { useState, useEffect, useRef } from "react";
import styled from 'styled-components';
// Social Commentary - Originals
import covid from "./assets/myWork/social_commentary/covid.png";
import metoo from "./assets/myWork/social_commentary/metoo.png";
import prize from "./assets/myWork/social_commentary/prize.png";
// Social Commentary - Compressed
import covidThumb from "./assets/myWork/social_commentary/covid_thumb.png";
import metooThumb from "./assets/myWork/social_commentary/metoo_thumb.png";
import prizeThumb from "./assets/myWork/social_commentary/prize_thumb.png";
// Teeth - Originals
import teeth1 from "./assets/myWork/teeth/Diana 牙齿组一220190330.jpg";
import teeth2 from "./assets/myWork/teeth/Diana 牙齿组二2 20190330.jpg";
import teeth3 from "./assets/myWork/teeth/Diana牙齿组三 20190330.jpg";
import fight from "./assets/myWork/teeth/fight.png";
import man from "./assets/myWork/teeth/man.png";
// Teeth - Compressed
import teeth1Thumb from "./assets/myWork/teeth/Diana 牙齿组一220190330_thumb.jpg";
import teeth2Thumb from "./assets/myWork/teeth/Diana 牙齿组二2 20190330_thumb.jpg";
import teeth3Thumb from "./assets/myWork/teeth/Diana牙齿组三 20190330_thumb.jpg";
import fightThumb from "./assets/myWork/teeth/fight_thumb.png";
import manThumb from "./assets/myWork/teeth/man_thumb.png";
// Travels - Originals
import corn from "./assets/myWork/travels/corn.png";
import diana1 from "./assets/myWork/travels/Diana20190616.jpg";
import diana2 from "./assets/myWork/travels/Diana20190619.jpg";
import grandparents from "./assets/myWork/travels/grandparents.png";
import kids from "./assets/myWork/travels/kids.png";
import twoGirls from "./assets/myWork/travels/two girls 2.png";
import parents from "./assets/myWork/travels/parents.JPG";
// Travels - Compressed
import cornThumb from "./assets/myWork/travels/corn_thumb.png";
import diana1Thumb from "./assets/myWork/travels/Diana20190616_thumb.jpg";
import diana2Thumb from "./assets/myWork/travels/Diana20190619_thumb.jpg";
import grandparentsThumb from "./assets/myWork/travels/grandparents_thumb.png";
import kidsThumb from "./assets/myWork/travels/kids_thumb.png";
import twoGirlsThumb from "./assets/myWork/travels/two girls 2_thumb.png";
import parentsThumb from "./assets/myWork/travels/parents_thumb.JPG";
import "./styles/gallery.css";

const GalleryLayout = styled.div`
  display: flex;
  gap: 4rem;
  max-width: 1600px;
  margin: 0 auto;
  padding: 2rem;

  @media (max-width: 968px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const SidebarContainer = styled.div`
  width: 30%;
  position: sticky;
  top: 120px;
  height: fit-content;
  
  @media (max-width: 968px) {
    display: none;
  }
`;

const SidebarContent = styled.div`
  opacity: ${props => props.$isVisible ? 1 : 0};
  transition: opacity 0.5s ease-in-out;
`;

const SidebarTitle = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 2.5rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
  text-transform: lowercase;
  
  @media (max-width: 968px) {
    font-size: 2rem;
  }
`;

const SidebarDescription = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
`;

const ContentContainer = styled.div`
  width: 70%;
  padding-bottom: 50vh;
  
  @media (max-width: 968px) {
    width: 100%;
    padding-bottom: 0;
  }
`;

const PortfolioSection = styled.div`
  margin-bottom: 8rem;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  @media (max-width: 968px) {
    margin-bottom: 4rem;
    
    &:last-child {
      margin-bottom: 2rem;
    }
  }
`;

const MobileSectionHeader = styled.div`
  display: none;
  
  @media (max-width: 968px) {
    display: block;
    margin-bottom: 2rem;
    
    h2 {
      font-family: 'Inter', sans-serif;
      font-size: 2rem;
      font-weight: 500;
      margin-bottom: 1rem;
      text-transform: lowercase;
    }
    
    p {
      font-family: 'Inter', sans-serif;
      font-size: 1rem;
      line-height: 1.6;
      color: #555;
    }
  }
`;

const Gallery = () => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [activeSection, setActiveSection] = useState(0);
  const sectionRefs = useRef([]);

  const portfolios = [
    {
      title: "people",
      description: "heartfelt moments, memories, and people that I relive by painting them",
      images: [
        { id: 9, imgSrc: corn, imgThumb: cornThumb, alt: "Corn" },
        { id: 10, imgSrc: diana1, imgThumb: diana1Thumb, alt: "Diana 2019" },
        { id: 11, imgSrc: diana2, imgThumb: diana2Thumb, alt: "Diana 2019" },
        { id: 12, imgSrc: grandparents, imgThumb: grandparentsThumb, alt: "Grandparents" },
        { id: 13, imgSrc: kids, imgThumb: kidsThumb, alt: "Kids" },
        { id: 14, imgSrc: twoGirls, imgThumb: twoGirlsThumb, alt: "Two Girls" },
        { id: 15, imgSrc: parents, imgThumb: parentsThumb, alt: "Parents" },
      ]
    },
    {
      title: "teeth",
      description: "i think teeth are overlooked in self-expression - so here's a series of paintings of teeth that emphasize vulnerability, authenticity, insecurity, and strength",
      images: [
        { id: 4, imgSrc: teeth1, imgThumb: teeth1Thumb, alt: "Teeth Series 1" },
        { id: 5, imgSrc: teeth2, imgThumb: teeth2Thumb, alt: "Teeth Series 2" },
        { id: 6, imgSrc: teeth3, imgThumb: teeth3Thumb, alt: "Teeth Series 3" },
        { id: 7, imgSrc: fight, imgThumb: fightThumb, alt: "Fight" },
        { id: 8, imgSrc: man, imgThumb: manThumb, alt: "Man" },
      ]
    },
    {
      title: "some thoughts of mine",
      description: `art sparks reflection and evolves our collective culture. with these pieces, I am adding my voice to ongoing conversations about cross-border cooperation, gender equity, and technological progress`,
      images: [
        { id: 1, imgSrc: covid, imgThumb: covidThumb, alt: "COVID" },
        { id: 2, imgSrc: metoo, imgThumb: metooThumb, alt: "Me Too" },
        { id: 3, imgSrc: prize, imgThumb: prizeThumb, alt: "Prize" },
      ]
    },
  ];

  // Track which section is in view
  useEffect(() => {
    const observers = sectionRefs.current.map((section, index) => {
      if (!section) return null;
      
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setActiveSection(index);
          }
        },
        {
          root: null,
          rootMargin: '-20% 0px -60% 0px',
          threshold: 0
        }
      );
      
      observer.observe(section);
      return observer;
    });

    return () => {
      observers.forEach(observer => observer && observer.disconnect());
    };
  }, []);

  const handleCloseModal = () => {
    setSelectedPhoto(null);
  };

  const handleModalClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCloseModal();
    }
  };

  return (
    <>
      <GalleryLayout>
        {/* Sticky Sidebar */}
        <SidebarContainer>
          {portfolios.map((portfolio, index) => (
            <SidebarContent 
              key={index} 
              $isVisible={activeSection === index}
              style={{ 
                position: activeSection === index ? 'relative' : 'absolute',
                top: 0,
                left: 0,
                width: '100%'
              }}
            >
              <SidebarTitle>{portfolio.title}</SidebarTitle>
              <SidebarDescription>{portfolio.description}</SidebarDescription>
            </SidebarContent>
          ))}
        </SidebarContainer>

        {/* Scrolling Content */}
        <ContentContainer>
          {portfolios.map((portfolio, portfolioIndex) => (
            <PortfolioSection 
              key={portfolioIndex}
              ref={el => sectionRefs.current[portfolioIndex] = el}
            >
              {/* Mobile: Show title/description above images */}
              <MobileSectionHeader>
                <h2>{portfolio.title}</h2>
                <p>{portfolio.description}</p>
              </MobileSectionHeader>
              
              <div className="gallery">
                {portfolio.images.map((item) => (
                  <div
                    className="pics"
                    key={item.id}
                    onClick={() => setSelectedPhoto(item)}
                    style={{ cursor: 'pointer' }}
                  >
                    <img src={item.imgThumb} alt={item.alt} style={{ width: "100%" }} />
                  </div>
                ))}
              </div>
            </PortfolioSection>
          ))}
        </ContentContainer>
      </GalleryLayout>

      {selectedPhoto && (
        <div className="modal" onClick={handleModalClick}>
          <div className="modal-content">
            <button className="close-button" onClick={handleCloseModal}>&times;</button>
            <img
              src={selectedPhoto.imgSrc}
              alt={selectedPhoto.alt}
              className="modal-image"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
